import { HeaderCategoryMenuCategories, RightAngleIcon } from '.';
import { basePath } from '@constants';

export type CategoryMenuCategories = HeaderCategoryMenuCategories;

export const Categories2: React.FC<{
  categories: CategoryMenuCategories;
}> = ({ categories }) => {
  return (
    <ul className='text-secondary'>
      {categories.map((category) => (
        <li key={category?.slug} className='border-b border-secondary-light'>
          <a
            href={`${basePath}/category/${category?.slug}/`}
            className='block flex items-center justify-between gap-3 py-4 hover:text-primary'
          >
            {category?.name}
            <RightAngleIcon className='h-4' />
          </a>
        </li>
      ))}
    </ul>
  );
};
